import { render, staticRenderFns } from "./CollectListDefaultLayout.vue?vue&type=template&id=e0642688&scoped=true&"
import script from "./CollectListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CollectListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0642688",
  null
  
)

export default component.exports